module.exports = __webpack_public_path__ + "static/media/ic_advertising_white.c499b4c9.svg";